import axios from 'axios';
import { getLocal } from '../utils/localStorageOps';
import { logoutExpiracao } from './authHandlers';
import { toast } from 'react-toastify';
import { isErroGeracaoSuspensa, MENSAGEM_GERACAO_SUSPENSA } from '../utils/geracaoBoleto';

const getToken = () => getLocal('token')

const zoopConfig = {
    marketplace_id: '79c2a5744b334606bf5e37019083db9b',
    zoop_token: 'enBrX3Byb2Rfc21aU1poU2ZxN0xLT2ZkdEtIRGNwZGFGOg==',
}

export const Api = axios.create({
    baseURL: 'https://api.paguedireto.com.br',
    // baseURL: 'https://tst-api.paguedireto.com.br',
    // baseURL: 'https://gc-tst-api.paguedireto.com.br',
    // baseURL: 'http://localhost:9134',
    // baseURL: "http://192.168.10.119:9104",
    // baseURL: "https://d81f-2804-2468-34c1-ed00-bd00-4f25-2831-7774.sa.ngrok.io/",
    timeout: 100000,
});

export const ApiAdimplencia = axios.create({
    baseURL: 'https://api-recorrencia.paguedireto.com.br',
    // baseURL: 'https://tst-api.paguedireto.com.br',
    // baseURL: 'https://gc-tst-api.paguedireto.com.br',
    // baseURL: 'http://localhost:9007',
    // baseURL: "http://192.168.10.119:9104",
    // baseURL: "https://d81f-2804-2468-34c1-ed00-bd00-4f25-2831-7774.sa.ngrok.io/",
    timeout: 100000,
});

export const ApiZoop = axios.create({
    baseURL: `https://api.zoop.ws/v1/marketplaces/${zoopConfig.marketplace_id}`,
    timeout: 50000,
});

export const ApiCarga = axios.create({
    baseURL: 'https://api-carga.paguedireto.com.br',
    // baseURL: 'https://tst-api-carga.paguedireto.com.br',
    // baseURL: 'http://localhost:7101',
    timeout: 100000,
});

ApiCarga.interceptors.request.use(async config => {
    const token = getToken();
    if (token)
        config.headers.Authorization = `Bearer ${token}`;

    return config;
});

ApiAdimplencia.interceptors.request.use(async config => {
    const token = getToken();
    if (token)
        config.headers.Authorization = `Bearer ${token}`;

    return config;
});

// Geração de boletos suspensa pelo admin: avisa o usuário com a mensagem padrão
// (toastId evita avisos duplicados); o erro segue para o tratamento da tela.
ApiAdimplencia.interceptors.response.use(
    response => response,
    error => {
        if (isErroGeracaoSuspensa(error)) {
            toast.warning(MENSAGEM_GERACAO_SUSPENSA, { toastId: 'geracao-boleto-suspensa' })
        }
        return Promise.reject(error)
    }
)

Api.interceptors.request.use(async config => {
    const token = getToken();
    if (token)
        config.headers.Authorization = `Bearer ${token}`;

    return config;
});

Api.interceptors.response.use(
    async response => {
        return response
    },
    async error => {
        const status = error.response?.status
        console.log('Erro de resposta:', status)

        if (status === 401) {
            logoutExpiracao()
        }

        return Promise.reject(error)
    }
)

ApiZoop.interceptors.request.use(async config => {
    config.headers.Authorization = `Basic ${zoopConfig.zoop_token}`;
    return config
})